export enum UnitKey {
  GA = "GA",
  BGD = "BGD",
  HQ = "HQ",
  PSC = "PSC",
  PVHK = "PVHK",
  AP = "AP",
  KT = "KT",
  PVHH = "PVHH",
}

export enum UnitCode {
  BGD_TSN = `BGD1`,
  HQ_TSN = `HQ1`,
  PSC_TSN = `PSC1`,
  PVHK_TSN = `PVHK1`,
  GA_TSN = `GA1`,
  BGD_NB = `BGD2`,
  HQ_NB = `HQ2`,
  PSC_NB = `PSC2`,
  PVHK_NB = `PVHK2`,
  AP_NB = `AP2`,
  KT_NB = `KT2`,
  BGD_DN = `BGD3`,
  HQ_DN = `HQ3`,
  PSC_DN = `PSC3`,
  PVHK_DN = `PVHK3`,
  AP_DN = `AP3`,
  KT_DN = `KT3`,
  PVHH_DN = `PVHH3`,
}

export const unitTSN = [
  {
    label: "Ban Giám đốc",
    value: `${UnitCode.BGD_TSN}|Ban Giám đốc`,
  },
  {
    label: "Trung tâm điều hành",
    value: `${UnitCode.HQ_TSN}|Trung tâm điều hành`,
  },
  {
    label: "Trung tâm phục vụ sân đỗ",
    value: `${UnitCode.PSC_TSN}|Trung tâm phục vụ sân đỗ`,
  },
  {
    label: "Trung tâm phục vụ hành khách",
    value: `${UnitCode.PVHK_TSN}|Trung tâm phục vụ hành khách`,
  },
  {
    label: "Nhóm hành chính tổng hợp",
    value: `${UnitCode.GA_TSN}|Nhóm hành chính tổng hợp`,
  },
];
export const unitNB = [
  {
    label: "Ban Giám đốc",
    value: `${UnitCode.BGD_NB}|Ban Giám đốc`,
  },
  {
    label: "Trung tâm điều hành",
    value: `${UnitCode.HQ_NB}|Trung tâm điều hành`,
  },
  {
    label: "Trung tâm phục vụ sân đỗ",
    value: `${UnitCode.PSC_NB}|Trung tâm phục vụ sân đỗ`,
  },
  {
    label: "Trung tâm phục vụ hành khách",
    value: `${UnitCode.PVHK_NB}|Trung tâm phục vụ hành khách`,
  },
  {
    label: "Phòng Kế hoạch hành chính",
    value: `${UnitCode.AP_NB}|Phòng Kế hoạch hành chính`,
  },
  {
    label: "Phòng Kế toán",
    value: `${UnitCode.KT_NB}|Phòng Kế toán`,
  },
];

export const unitDN = [
  {
    label: "Ban Giám đốc",
    value: `${UnitCode.BGD_DN}|Ban Giám đốc`,
  },
  {
    label: "Trung tâm điều hành",
    value: `${UnitCode.HQ_DN}|Trung tâm điều hành`,
  },
  {
    label: "Trung tâm phục vụ sân đỗ",
    value: `${UnitCode.PSC_DN}|Trung tâm phục vụ sân đỗ`,
  },
  {
    label: "Trung tâm phục vụ hành khách",
    value: `${UnitCode.PVHK_DN}|Trung tâm phục vụ hành khách`,
  },
  {
    label: "Phòng Kế hoạch hành chính",
    value: `${UnitCode.AP_DN}|Phòng Kế hoạch hành chính`,
  },
  {
    label: "Phòng Kế toán",
    value: `${UnitCode.KT_DN}|Phòng Kế toán`,
  },
  {
    label: "Trung tâm phục vụ hàng hóa",
    value: `${UnitCode.PVHH_DN}|Trung tâm phục vụ hàng hóa`,
  },
];

export const units = [...unitTSN, ...unitNB, ...unitDN];
